import { useState } from 'react';
import { scrollToSection } from '../utils/helpers';
import useTheme from '../utils/useTheme';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const { theme, toggleTheme } = useTheme();

    // Menu items and their section ids
    const menu = [
        // { label: "Home", id: "home" },
        { label: "About", id: "about" },
        { label: "Projects", id: "projects" },
        { label: "Publications", id: "publications" },
        { label: "Lab & Team", id: "labs" },
        // { label: "Courses", id: "courses" },
        // { label: "Contact", id: "contact" },
    ];

    const handleMenuClick = (id) => {
        scrollToSection(id);
        setIsOpen(false);
    };

    const themeToggle = (
        <button
            onClick={toggleTheme}
            className="text-gray-500 hover:text-primary dark:text-gray-400 dark:hover:text-blue-400 transition-colors flex items-center"
            aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
            title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
        >
            <span className="material-icons text-xl">{theme === 'dark' ? 'light_mode' : 'dark_mode'}</span>
        </button>
    );

    return (
        <nav className="fixed top-0 left-0 w-full z-50 bg-surface-light/90 dark:bg-surface-dark/90 backdrop-blur-md shadow-sm border-b border-gray-200 dark:border-gray-700 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={() => handleMenuClick("home")}
                    >
                        <span className="text-xl font-display font-bold text-primary dark:text-blue-400">Dr. Priyanka Katiyar</span>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        {menu.map(item => (
                            <button
                                key={item.id}
                                className="text-sm font-medium hover:text-primary dark:hover:text-blue-400 transition-colors"
                                onClick={() => handleMenuClick(item.id)}
                            >
                                {item.label}
                            </button>
                        ))}
                        {themeToggle}
                        <button
                            className="px-4 py-2 text-sm font-medium bg-primary text-white rounded-md hover:bg-blue-800 transition-colors shadow-sm"
                            onClick={() => handleMenuClick('contact')}
                        >
                            Contact
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="flex items-center space-x-4 md:hidden">
                        {themeToggle}
                        <button
                            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                            onClick={() => setIsOpen(!isOpen)}
                            aria-label="Toggle menu"
                        >
                            <span className="material-icons">{isOpen ? 'close' : 'menu'}</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isOpen && (
                <div
                    className="md:hidden fixed inset-0 z-40 bg-surface-light dark:bg-surface-dark pt-16 flex flex-col h-screen"
                >
                    <div className="px-4 pt-2 pb-3 space-y-1 flex flex-col h-full overflow-y-auto">
                        <button
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 p-2"
                            onClick={() => setIsOpen(false)}
                        >
                            <span className="material-icons text-2xl">close</span>
                        </button>

                        <div className="flex flex-col space-y-4 mt-8">
                            {menu.map((item) => (
                                <button
                                    key={item.id}
                                    className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 dark:text-gray-200 hover:text-primary dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors"
                                    onClick={() => handleMenuClick(item.id)}
                                >
                                    {item.label}
                                </button>
                            ))}
                            <button
                                className="mt-4 w-full text-center px-4 py-3 text-base font-medium bg-primary text-white rounded-md hover:bg-blue-800 transition-colors shadow-sm"
                                onClick={() => handleMenuClick('contact')}
                            >
                                Contact
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
} 